import script from "./ProjectCommentCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCommentCreate.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectCommentCreate.vue?vue&type=style&index=0&id=8dd547da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dd547da"]])

export default __exports__